module.exports = __webpack_public_path__ + "static/media/FTSI_Logo_Only_PROD.5affb323.png";